export function isNullOrWhitespace(input?: null | string): input is null | undefined {
  if (typeof input !== "string") {
    return true;
  }

  return input.trim() === "";
}
